module.exports = __webpack_public_path__ + "static/media/logout.12ff9923.svg";